import { render, staticRenderFns } from "./ReglementInfos.vue?vue&type=template&id=3e8fafe9&"
import script from "./ReglementInfos.vue?vue&type=script&lang=js&"
export * from "./ReglementInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8fafe9')) {
      api.createRecord('3e8fafe9', component.options)
    } else {
      api.reload('3e8fafe9', component.options)
    }
    module.hot.accept("./ReglementInfos.vue?vue&type=template&id=3e8fafe9&", function () {
      api.rerender('3e8fafe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/reglements/ReglementInfos.vue"
export default component.exports